import { motion } from "framer-motion";
import { BadgeCheck, PackageSearch, Truck, Headset } from "lucide-react";

const ITEMS = [
  {
    num: "01",
    icon: BadgeCheck,
    title: "Uncompromising Quality",
    body: "Every item we supply is vetted against strict standards. If it does not meet our benchmark, it does not carry our name.",
  },
  {
    num: "02",
    icon: PackageSearch,
    title: "Tailored Procurement",
    body: "No catalogue limitations. Describe the exact goods your business needs and our team sources them to specification.",
  },
  {
    num: "03",
    icon: Truck,
    title: "Dedicated Logistics",
    body: "From confirmation to doorstep, each order is tracked and managed with attention to detail.",
  },
  {
    num: "04",
    icon: Headset,
    title: "Direct Support",
    body: "You deal directly with our team — no call centres, no queues. Your notes and concerns reach us instantly.",
  },
];

export default function ManifestoSection() {
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="bg-cream-100 border-y border-cream-200 py-16 lg:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mb-12"
        >
          <span className="eyebrow" data-testid="manifesto-eyebrow">
            Why Choose Us
          </span>
          <h2 className="mt-4 font-poppins font-semibold text-2xl sm:text-3xl text-charcoal-900">
            Four principles behind every order we fulfil
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {ITEMS.map((item, i) => (
            <motion.div
              key={item.num}
              data-testid={`manifesto-chapter-${item.num}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="bg-white border border-cream-200 rounded-xl p-6"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-cream-100 border border-cream-200">
                <item.icon className="h-5 w-5 text-taupe-600" />
              </span>
              <h3 className="mt-5 font-poppins font-semibold text-base text-charcoal-900">
                {item.title}
              </h3>
              <p className="mt-3 text-sm text-charcoal-700 leading-relaxed">
                {item.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
